import React, { useState } from 'react';
import { ClockIcon, FlameIcon } from 'lucide-react';
import MinutesTable from './MinutesTable';
import FullTimeline from './FullTimeline';
import ScoringTimeline from './ScoringTimeline';
type TimelineTab = 'full' | 'scoring';
const TABS: Array<{
  id: TimelineTab;
  label: string;
  icon: React.ReactNode;
}> = [{
  id: 'full',
  label: 'Full timeline',
  icon: <ClockIcon className="w-4 h-4 mr-2" data-id="element-105" data-mp="1ltye872crchd" />
}, {
  id: 'scoring',
  label: 'Scoring timeline',
  icon: <FlameIcon className="w-4 h-4 mr-2" data-id="element-106" data-mp="1qssvv5ol2uzw" />
}];
const GameTimeline = () => {
  const [activeTab, setActiveTab] = useState<TimelineTab>('full');
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-107" data-mp="1vsxbyulkxnpl">
      <h2 className="text-xl font-bold mb-6" data-id="element-108" data-mp="1zu0s7i7jhlrc">Game Timeline</h2>

      <MinutesTable data-id="element-109" data-mp="1zreltlwdxcap" />

      <div className="border-b border-gray-200 mb-6" role="tablist" data-id="element-110" data-mp="1emooqkmv1lx">
        {TABS.map(tab => <button key={tab.id} role="tab" type="button" aria-selected={activeTab === tab.id} onClick={() => setActiveTab(tab.id)} className={`inline-flex items-center px-4 py-3 text-sm font-medium border-b-2 -mb-px ${activeTab === tab.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-800'}`} data-id="element-111" data-mp="5f6jhnhqht4w">
            {tab.icon}
            {tab.label}
          </button>)}
      </div>

      {activeTab === 'full' ? <FullTimeline data-id="element-112" data-mp="3p4wyab6u6fnd" /> : <ScoringTimeline data-id="element-113" data-mp="3p4dqhnawh7n2" />}
    </div>;
};
export default GameTimeline;